<template>
    <div class="level__bonus card">
        <a class="helper__tooltip" :href="unilevelLink" target="_blank">
            <h2 v-html="t.title"></h2>
        </a>
        <div class="template__grid">
            <!-- <div class="container__in"> -->
            <section class="first">
                <h2>{{t.label_personal_sales}} #0</h2>
                <div class="first__in">
                    <div class="leads">
                        <div>
                            <span v-html="t.leads"></span>
                            <span>{{allData.level_zero.leads}}</span>
                        </div>
                        <div>
                            <span v-html="t.active_leads"></span>
                            <span>{{allData.level_zero.active_leads}}</span>
                        </div>
                        <div>
                            <span v-html="t.affiliates"></span>
                            <span>{{allData.level_zero.affiliates}}</span>
                        </div>
                    </div>
                    <div class="values">
                        <!-- <span>USD {{allData.level_one.USD}}</span>
                            <span>BRL {{allData.level_one.BRL}}</span>
                        <span>EUR {{allData.level_one.EUR}}</span>-->
                    </div>
                </div>
            </section>
            <section class="second">
                <h2>{{t.level}} #1</h2>
                <div class="first__in">
                    <div class="leads">
                        <div>
                            <span v-html="t.leads"></span>
                            <span>{{allData.level_one.leads}}</span>
                        </div>
                        <div>
                            <span v-html="t.active_leads"></span>
                            <span>{{allData.level_one.active_leads}}</span>
                        </div>
                        <div>
                            <span v-html="t.affiliates"></span>
                            <span>{{allData.level_one.affiliates}}</span>
                        </div>
                    </div>
                    <div class="values">
                        <span>USD {{allData.level_one.USD}}</span>
                        <span>BRL {{allData.level_one.BRL}}</span>
                        <span>EUR {{allData.level_one.EUR}}</span>
                    </div>
                </div>
            </section>
            <!-- </div> -->
            <!-- <div class="container__in"> -->
            <section class="third">
                <h2>{{t.level}} #2</h2>
                <div class="first__in">
                    <div class="leads">
                        <div>
                            <span v-html="t.leads"></span>
                            <span>{{allData.level_two.leads}}</span>
                        </div>
                        <div>
                            <span v-html="t.active_leads"></span>
                            <span>{{allData.level_two.active_leads}}</span>
                        </div>
                        <div>
                            <span v-html="t.affiliates"></span>
                            <span>{{allData.level_two.affiliates}}</span>
                        </div>
                    </div>
                    <div class="values">
                        <span>USD {{allData.level_two.USD}}</span>
                        <span>BRL {{allData.level_two.BRL}}</span>
                        <span>EUR {{allData.level_two.EUR}}</span>
                    </div>
                </div>
            </section>
            <section class="fourth">
                <h2>{{t.level}} #3</h2>
                <div class="first__in">
                    <div class="leads">
                        <div>
                            <span v-html="t.leads"></span>
                            <span>{{allData.level_three.leads}}</span>
                        </div>
                        <div>
                            <span v-html="t.active_leads"></span>
                            <span>{{allData.level_three.active_leads}}</span>
                        </div>
                        <div>
                            <span v-html="t.affiliates"></span>
                            <span>{{allData.level_three.affiliates}}</span>
                        </div>
                    </div>
                    <div class="values">
                        <span>USD {{allData.level_three.USD}}</span>
                        <span>BRL {{allData.level_three.BRL}}</span>
                        <span>EUR {{allData.level_three.EUR}}</span>
                    </div>
                </div>
            </section>
            <!-- </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: "level-info",
    components: {},
    data() {
        return {
            t: this.$parent.view.translation.leads_bonus,
            allData: this.$parent.view.dashboard_values_v3.level_bonus,
            unilevelLink: this.$parent.view.unilevelUrl
        };
    },
    methods: {},
    mounted() {
        // console.log(this.t);
    }
};
</script>
<style scoped lang="scss">
.level__bonus {
    .template__grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        margin-top: 1.5rem;
    }
    h2 {
        font-family: "Muli";
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        color: #707070;
        margin: 0;
    }
    .container__in {
        margin: 1rem 0;
    }
    .first,
    .second,
    .third,
    .fourth {
        h2 {
            font-weight: normal;
            font-size: 16px;
            text-align: center;
            margin-bottom: 0.8rem;
        }
        .leads {
            text-align: right;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            span {
                &:last-child {
                    color: #0294ff;
                    font-weight: bold;
                }
            }
        }
        .first__in {
            display: flex;
            justify-content: space-evenly;
        }
        .values {
            font-family: "Muli";
            color: #0294ff;
            font-weight: bold;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            span {
                font-size: 1.2rem;
            }
        }
    }
}
@media (max-width: 1600px) {
    .level__bonus .template__grid {
        grid-template-columns: auto;
    }
    .first,
    .second,
    .third,
    .fourth {
        h2 {
            margin-top: 2rem;
            margin-bottom: 0.8rem;
        }
    }
}
@media (max-width: 650px) {
    .level__bonus .first h2,
    .level__bonus .second h2,
    .level__bonus .third h2 {
        margin: 2rem 0 1rem 0;
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/levelInfo.vue